export default (query) => query.split(',').map((q) => q.trim()).filter((i) => i !== '');
